import React, { useEffect, useState } from "react";
// import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../../node_modules/swiper/swiper.min.css";
import { useSelector } from "react-redux";
import dynamic from "next/dynamic";

const CareersPromise = dynamic(() => import("./CareersPromise"));
const JobPosition = dynamic(() => import("./JobPosition"));
const CareersHero = dynamic(() => import("./CareersHero"));
const CareerInsight = dynamic(() => import("./CareerInsight"));
const CareerCtaGradient = dynamic(() => import("./CareerCtaGradient"));
const OurCulture = dynamic(() => import("./OurCulture"));
const PerksBenefits = dynamic(() => import("./PerksBenefits"));

const Career = ({ carrerData }) => {
  const [FooterIcon, setFooterIcon] = useState();

  const headerFooterData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  // insights image start
  useEffect(() => {
    if (headerFooterData) {
      const filterData = headerFooterData?.common_images?.filter((item) => {
        return item?.title == "Insights Icon";
      });
      filterData && setFooterIcon(filterData);
    }
  }, []);

  useEffect(() => {
    console.clear();
  }, []);
  //  insights image end
  return (
    <main className="main-wrapper careers-page-middle wrapper-pt-0">
      <article className="wrapper-inner">
        {carrerData?.map((val, index) => {
          switch (val?.type) {
            case "careers_banner":
              return <CareersHero key={index} carrerData={val} />;
            case "careers_insights_section":
              return (
                <CareerInsight
                  key={index}
                  carrerData={val}
                  FooterIcon={FooterIcon}
                />
              );
            case "job_position":
              return <JobPosition key={index} modaldata={carrerData} />;
            case "cta":
              return <CareerCtaGradient key={index} carrerData={val} />;
            case "careers_promises":
              return <CareersPromise key={index} data={val} />;
            case "culture":
              return <OurCulture key={index} carrerData={val} />;
            case "perks_benefits":
              return <PerksBenefits key={index} carrerData={val} />;
          }
        })}
      </article>
    </main>
  );
};

export default Career;
